import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {environment} from '@env/environment';
import {IsEnterpriseUserGuard} from '@shared/guards/is-enterprise-user.guard';
import {resolveMailboxAccess} from '@shared/helpers/mailbox/mailbox-access';
import {AuthService} from '@shared/services/auth.service';
import {filter, switchMap, take} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

/**
 * Mailbox: erst Rollout (Dev/Beta/JUG), dann Tarif (ENTERPRISE, bei JUG egal) – siehe resolveMailboxAccess.
 * Der Tarif-Fall delegiert an IsEnterpriseUserGuard, damit die 431-Seite Feature-Kontext und returnUrl bekommt.
 */
export const canAccessMailboxGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const enterpriseUserGuard = inject(IsEnterpriseUserGuard);

    return authService.tier$.pipe(
        filter((tier) => tier !== undefined),
        take(1),
        switchMap((tier) => {
            switch (resolveMailboxAccess(environment, tier)) {
                case 'granted':
                    return of(true);
                case 'rollout-blocked':
                    return of(router.createUrlTree(['fehler', '403'], {
                        queryParams: {permission: 'MAILBOX_CUSTOMER_READY'},
                    }));
                default:
                    // canAccess liefert immer ein Observable (tier$-Pipe); die weite Guard-Signatur braucht den Cast
                    return enterpriseUserGuard.canAccess(route.data?.upgradeFeature ?? 'mailbox', state?.url) as Observable<boolean | UrlTree>;
            }
        })
    );
};
